import React from 'react'
import ReactDOM from 'react-dom/client';
// Reset & Element style
import './themes/styles/bases/reset'
import './themes/styles/bases/scaffolding'
// Component style
import './components/custom/AccordionControl/styled'
import './components/custom/Button/styled'
import './components/custom/Chart/styled'
import './components/custom/CmsLayout/styled'
import './components/custom/Container/styled'
import './components/custom/Field/styled'
import './components/custom/Grid/styled'
import './components/custom/Image/styled'
import './components/custom/Modal/styled'
import './components/custom/Notification/styled'
import './components/custom/PaginationControl/styled'
import './components/custom/Section/styled'
import './components/custom/ShapeContainer/styled'
import './components/custom/Table/styled'
import './components/custom/Text/styled'
// Page & Global style
import ReactGA from 'react-ga'
import App from './App'

import GlobalStyle from  './themes/styles/layouts/global';
import './themes/styles/layouts/page';
import { ThemeProvider } from "styled-components";
import ScaffoldingStyles from  './themes/styles/bases/scaffolding';
import ResetStyles from  './themes/styles/bases/reset';
import { VARIABLES } from './themes';

ReactGA.initialize('UA-150843057-3');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={VARIABLES}>
      <GlobalStyle />
      <ScaffoldingStyles />
      <ResetStyles />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
